export enum localStorageKeys {
  accessToken = 'accessToken',
  refreshToken = 'refreshToken',
  expiredIn = 'expiredIn',
}
